import $ from "jquery";
import './formulairesJira.scss';

let boiteMessage = null;

jQuery(function() {
	$("#formFeuilletsFiscaux").after("<p class='message'></p>");
	$("#formFeuilletsFiscaux #feuilletsFiscauxNonce").attr("value", vradho.nonce);

	boiteMessage = $("#formFeuilletsFiscaux").parent().find(".message");

	$("#formFeuilletsFiscaux").on("submit", function(e) {
		e.preventDefault();
		$("#formFeuilletsFiscaux input[type='submit']").attr("disabled", "disabled");
		boiteMessage.text("En traitement...");
		creerDemande($(this));
		return false;
	});
});


function creerDemande(form) {
	$.ajax({
		type: "POST",
		url: vradho.ajax_url,
		data: $(form).serialize() + "&action=vradho_formulairesJira_creerDemande",
		success: function(data){
			$(form).trigger("reset");
			boiteMessage.text("Votre demande a été envoyée.");
		},
		error: function(data, errorString){
			boiteMessage.text("Une erreur s'est produite. Veuillez réessayer.");
			console.log(data, errorString);
		}
	}).always(function() {
		$(form).find("input[type='submit']").removeAttr("disabled");
	});
}
